import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuthContext } from '../contexts/AuthProvider';
import { FeatureName } from '../types/features';
import useFeatureBasedPermissions from './useFeatureBasedPermissions';

const useCheckUserFeaturePermissions = (
  featureName: FeatureName,
  clientHasReadPermission?: boolean
) => {
  // integration of react-router-dom hooks here
  const navigate = useNavigate();

  // integration of context hooks here
  const { currentUserType } = useAuthContext();

  // integration of custom hooks here
  const { featureBasedPermissions } = useFeatureBasedPermissions(featureName);

  // redirecting user to dashboard if he/she don't have read permission
  useEffect(() => {
    console.log('FEATURE CONFIG: ', featureBasedPermissions);
    if (clientHasReadPermission) {
      if (currentUserType === 'client') {
        return;
      }
    } else {
      if (
        featureBasedPermissions &&
        (!featureBasedPermissions.length ||
          !featureBasedPermissions.includes('READ'))
      ) {
        navigate('/dashboard');

        toast.error('Access Denied!!', { toastId: 'access-denied' });
      }
    }
  }, [
    featureBasedPermissions,
    navigate,
    currentUserType,
    clientHasReadPermission,
  ]);

  return clientHasReadPermission && currentUserType === 'client'
    ? { featureBasedPermissions: ['READ'] }
    : { featureBasedPermissions };
};

export default useCheckUserFeaturePermissions;
